import {Container} from "./Container"

export const RestorePassFormStyles = {
    Container
}